import { useSelector } from "react-redux";
import ProgressBar from "./ProgressBar";

export default function ProgressWrapper() {
  const isAnimating = useSelector((state) => state.progress.isAnimating);

  return <ProgressBar isAnimating={isAnimating} />;
}
